import { doc } from 'firebase/firestore'
import useReportDocId from './useReportDocId'
import useActiveUid from './useActiveUid'
import { getEffectiveServices } from '../utils/firebaseServiceContext'

export default () => {
  const month = useReportDocId()
  const uid = useActiveUid()
  if (!uid) {
    throw new Error('Cannot determine user for report path.')
  }
  return doc(
    getEffectiveServices().firestore,
    `users/${uid}/reports/${month}`,
  )
}
